var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import NotificationSystem from 'react-notification-system';
// The library's own container z-index (9998) sits under BaseModal's backdrop (9999, BaseModal.styl),
// so a toast fired from inside a modal (e.g. a failed login) rendered behind the dark scrim and was
// effectively invisible. Lift every container above all modal layers.
const NOTIFICATION_STYLE = { Containers: { DefaultStyle: { zIndex: 10000 } } };
let Notification = class Notification extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "notificationRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    componentDidMount() {
        this.props.notificationStore.setRef(this.notificationRef);
    }
    componentWillUnmount() {
        this.props.notificationStore.setRef(null);
    }
    render() {
        return React.createElement(NotificationSystem, { ref: (ref) => (this.notificationRef = ref), style: NOTIFICATION_STYLE });
    }
};
Notification = __decorate([
    inject('notificationStore'),
    observer
], Notification);
export default Notification;
